import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import sanitizeItemContextMetadata from './sanitizeItemContextMetadata'

function getMerchandiseItems(order: App.Order, isMultiCart?: boolean) {
  return order.merchandiseItems.map(orderItem => {
    return comluxgroup.createItem_1_1_2({
      offerId: orderItem.offerId,
      categoryId: 'shop',
      productId: 'merchandise',
      price: orderItem.total,
      currency: order.currencyCode,
      itemId: orderItem.id,
      orderId: order.id,
      metadata: sanitizeItemContextMetadata({
        isMultiCart,
      }),
    })
  })
}

export default getMerchandiseItems
